// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dAHG","colMin":"styles_colMin__NRq69"};